import { type FC, useState } from 'react';
import StyledLink from '@/components/common/StyledLink';
import { DESIGN_SYSTEM_SIZES } from '@/constants/styles';
import { useAppSelector } from '@/redux';
import { selectBlogMenu } from '@/redux/slices/blog.slice';
import { MenuItem } from '@/types';
import styles from './BlogMenuDesktop.module.scss';

export const BlogMenuDesktop: FC = () => {
	const blogMenu = useAppSelector(selectBlogMenu);

	const [selectedMenu, setSelectedMenu] = useState(null);

	const getSubmenuComponent = (type, subMenus, subLinks) => {
		switch (type) {
			case 'LINKS':
				return subMenus.map(({ title, subLinks }) => (
					<div className={styles['sub-menu']} key={title.label}>
						<span className={styles['sub-menu-title']}>{title}</span>
						{subLinks.map(({ label, link }) => (
							<StyledLink
								href={link}
								label={label}
								key={label}
								size={DESIGN_SYSTEM_SIZES.SMALL}
								isUnderlined={false}
							/>
						))}
					</div>
				));
			case 'IMAGES':
				return subLinks.map(({ label, link, img }) => (
					<a
						key={label}
						className={styles['image-item']}
						href={link}
						style={{
							background: `linear-gradient(180deg, rgba(131, 131, 131, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%), url(${img})`,
						}}
					>
						{label}
					</a>
				));
			default:
				return <></>;
		}
	};

	const getMenuItemClass = (index) => {
		return `${styles['menu-item']} ${index === selectedMenu ? styles.active : selectedMenu !== null ? styles.inactive : ''}`;
	};

	return blogMenu?.length > 0 ? (
		<>
			{selectedMenu != null && <div className={styles.overlay} />}
			<div className={styles.container} data-test-id="blog-menu-desktop">
				<div className={styles.layout} onMouseLeave={() => setSelectedMenu(null)}>
					{blogMenu.map(({ title, type, subMenus, subLinks }: MenuItem, index) => (
						<div className={getMenuItemClass(index)} onMouseEnter={() => setSelectedMenu(index)} key={title}>
							{title}
							<div
								className={`${styles['sub-menu-container']}${selectedMenu === index ? ` ${styles['sub-menu-container--open']}` : ''}`}
							>
								{getSubmenuComponent(type, subMenus, subLinks)}
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	) : null;
};

export default BlogMenuDesktop;
